import type { MouseEvent } from "react";
import type { MonitorState } from "@/components/widgets/Monitor/type";
import type { WidgetScreenerState } from "@/components/widgets/Screener/type";
import { useMosaic } from "@/context/mosaic/MosaicContext";
import { useTabs } from "@/context/tabs/TabsContext";
import { updateLinkedTiles } from "@/shared/helpers/updateLinkedTiles";
import type { ViewId } from "@/shared/types/common";

interface UseHandleCellClickProps {
	tileId: string;
	onTickerSelect?: (ticker: string) => void;
}

export const useHandleCellClick = ({
	tileId,
	onTickerSelect,
}: UseHandleCellClickProps) => {
	const { setClickInfo } = useMosaic();
	const { getWidgetState, setWidgetState } = useTabs();
	const state = getWidgetState(tileId as ViewId);

	return (_: any, event: MouseEvent) =>
		updateLinkedTiles(
			event,
			state,
			setWidgetState,
			tileId,
			setClickInfo,
			(state as MonitorState | WidgetScreenerState)?.isOneClickTrigger ?? false,
			onTickerSelect,
		);
};
